module.exports = __webpack_public_path__ + "img/logo.eeeabbb4.png";